import React, { useState, useEffect } from 'react';
import Picker from 'react-mobile-picker';
import './VisitsMonitoring.css';

function VisitsMonitoring({ profile, onBack }) {
  const [pickerValue, setPickerValue] = useState({ day: '' });
  const [selectedDay, setSelectedDay] = useState('');
  const [visitData, setVisitData] = useState([]);
  const [days, setDays] = useState([]);
  const [maxMinutesPerDay, setMaxMinutesPerDay] = useState(0);
  const [totalMinutesEachDay, setTotalMinutesEachDay] = useState([]);


  const [loading, setLoading] = useState(false); // Состояние загрузки


  // Обработка изменения значения в Picker
  const handlePickerChange = (value) => {
	setPickerValue(value);
	setSelectedDay(value.day);
  };

  // Получение данных посещений
useEffect(() => {
	
	setLoading(true);


	const fetchVisitData = async () => {
	  //const today = Math.floor(Date.now() / 1000); // Текущая Unix метка времени
	  
	  const now = new Date();
	  now.setHours(0, 0, 0, 0); // Устанавливаем время на 00:00 текущего дня
	  const today = Math.floor(now.getTime() / 1000); // Unix метка времени для полуночи



	  const userId = profile.id;
  
	  try {
		const formData = new URLSearchParams();
		formData.append('user_id', userId);
		formData.append('today', today);
		formData.append('today_date', new Date().toISOString().split('T')[0]);
  
		const response = await fetch('http://212.109.216.87/mytracker25_site/edited/monitoring_of_visits.php', {
		  method: 'POST',
		  headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		  },
		  body: formData.toString(),
		});
  
		const data = await response.json();
		console.log('Ответ по JSON:', data);
		console.log('Количество записей в statistics:', data.statistics ? data.statistics.length : 'Нет данных');
		setVisitData(data.daily_activity);
		setMaxMinutesPerDay(data.max_minutes_per_day);
		setTotalMinutesEachDay(data.total_minutes_each_day.split(',').map(Number));
  
		const capitalizeFirstLetter = (string) => {
		  return string.charAt(0).toUpperCase() + string.slice(1);
		};
  
		const formattedDays = data.daily_activity.map((day, index) => {
		  const date = new Date(day.day_start_unix * 1000);
		  const today = new Date();
		  const yesterday = new Date();
		  yesterday.setDate(today.getDate() - 1);
  
		  if (date.toDateString() === today.toDateString()) {
			return `Сегодня, ${date.toLocaleDateString('ru-RU', { month: 'long', day: 'numeric' })}`;
		  } else if (date.toDateString() === yesterday.toDateString()) {
			return `Вчера, ${date.toLocaleDateString('ru-RU', { month: 'long', day: 'numeric' })}`;
		  } else {
			let localeString = date.toLocaleDateString('ru-RU', {
			  weekday: 'long',
			  month: 'long',
			  day: 'numeric',
			});
			// Преобразуем первую букву в заглавную
			return capitalizeFirstLetter(localeString);
		  }
		});
  
		setDays(formattedDays);
		setPickerValue({ day: formattedDays[0] });
		setSelectedDay(formattedDays[0]);
		
		// Добавляем задержку перед отключением состояния загрузки
		setTimeout(() => {
		  setLoading(false);
		}, 700); // Задержка в 500 миллисекунд
		
		
		
	  } catch (error) {
		console.error('Ошибка получения данных посещений: ', { userId }, { today }, new Date().toISOString().split('T')[0]);
		
		// Добавляем задержку перед отключением состояния загрузки
		setTimeout(() => {
		  setLoading(false);
		}, 700); // Задержка в 500 миллисекунд
		
		
		
	  }
	};
  
	fetchVisitData();
  }, [profile.id]);


  return (
	  
	 
		<>
		
		   {/* Индикатор загрузки, который выводится поверх всех элементов */}
		   
		   
		 
	<div className="App">

	
	
	  <div className="top-bar-profile">
		<div className="top-bar-inside-profile">
		  <button className="back-button" onClick={onBack}>
			<img
				src="images/strelka_left_menu_bar.png"
				alt="Назад"
				className="back-button-image"
			  />
		  </button>
		  <h2 className="profile-name-centered">Мониторинг посещений</h2>
		  <div className="button-group-right">
		  			
			<img
			  src={profile.avatar}
			  alt={profile.name}
			  className="profile-avatar-topbar"
			/>
			
			
		  </div>
		</div>
		
		
	  </div>


	<div className="visits-monitoring">
			{/* Отображение выбранного дня */}
			
		  {/* UI Picker с одной колонной */}
		  <Picker
			value={pickerValue}
			onChange={handlePickerChange}
			wheelMode="natural"
			height={70}         // Уменьшенная общая высота пикера
			itemHeight={25}     // Уменьшенная высота каждого элемента
		  >
			<Picker.Column name="day">
			  {days.map((day, index) => (
				<Picker.Item key={day} value={day}>
				  {({ selected }) => {
					// Определяем угол вращения для каждого элемента в зависимости от его положения
					let rotationAngle = 0;
					if (!selected) {
					  if (index < days.indexOf(pickerValue.day)) {
						rotationAngle = 20; // Верхний элемент наклоняется вверх
					  } else if (index > days.indexOf(pickerValue.day)) {
						rotationAngle = -20;  // Нижний элемент наклоняется вниз
					  }
					}
		  
					return (
					  <div
						style={{
						  color: selected ? '#ffffff' : '#fffc',           // Цвет текста
						  fontWeight: selected ? 'normal' : 'normal',      // Жирность текста
						  transform: `perspective(1000px) rotateX(${rotationAngle}deg) scale(${selected ? 1.1 : 1})`, // 3D-изгиб и увеличение при выборе
						  transformOrigin: 'center',                       // Точка вращения - центр элемента
						  transition: 'transform 0.5s, color 0.5s',        // Плавность изменений
						}}
					  >
						{day}
					  </div>
					);
				  }}
				</Picker.Item>
			  ))}
			</Picker.Column>
		  </Picker>
	  
	  
	  
		 </div>
		 
		 
		 
	  <header className="App-header-monitoring">
	  
	
		  
		  {/* Блоки посещений (row-style) */}
		  <div className="visits-blocks">
		  
		  {loading
		  ? Array.from({ length: 22 }).map((_, index) => (
			<>
			  <div key={index} className="visit-row-loading">
			  </div>
			  </>
			))
		  
			: visitData
			  .filter((day) => {
				const date = new Date(day.day_start_unix * 1000);
				let formattedDay;
				const today = new Date();
				const yesterday = new Date();
				yesterday.setDate(today.getDate() - 1);
			  
				const capitalizeFirstLetter = (string) => {
				  return string.charAt(0).toUpperCase() + string.slice(1);
				};
			  
				if (date.toDateString() === today.toDateString()) {
				  formattedDay = `Сегодня, ${date.toLocaleDateString('ru-RU', { month: 'long', day: 'numeric' })}`;
				} else if (date.toDateString() === yesterday.toDateString()) {
				  formattedDay = `Вчера, ${date.toLocaleDateString('ru-RU', { month: 'long', day: 'numeric' })}`;
				} else {
				  // Форматируем день недели и остальные части строки отдельно
				  const weekday = capitalizeFirstLetter(
					date.toLocaleDateString('ru-RU', { weekday: 'long' })
				  );
				  const restOfDate = date.toLocaleDateString('ru-RU', {
					month: 'long',
					day: 'numeric',
				  });
			  
				  // Соединяем отформатированный день недели и остальные части
				  formattedDay = `${weekday}, ${restOfDate}`;
				}
			  
				return formattedDay === selectedDay;
			  })
			  
			
				
			  .map((day, dayIndex) =>
				day.daily_interval_info.map((visit, index) => (
				  <div key={`${dayIndex}-${index}`} className="visit-row">
				  
					<div className="visit-time">
					  <span>{new Date(visit.interval_in * 1000).toLocaleTimeString('ru-RU')} - {new Date(visit.interval_out * 1000).toLocaleTimeString('ru-RU')}</span>
					</div>
					
					<div className="visit-icons">
					  <span className="visit-icon">  {visit.actions_count}</span>
					  <span className="visit-icon">  {visit.surf_time_minutes} мин.</span>
					</div>
					{ /* //тут был собеседник
					//<div className="visit-candidate">
					//{visit.candidate.name !== 'netkandidata' ? visit.candidate.name : 'Явного собеседника не было'}
					//</div> */}
				  </div>
				))
			  )}
		  
		  </div>
		
	  </header>
	</div>
	
	</>
	
  );
}

export default VisitsMonitoring;
